import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=7275d748&scoped=true&"
import script from "./Match.vue?vue&type=script&lang=ts&"
export * from "./Match.vue?vue&type=script&lang=ts&"
import style0 from "./Match.vue?vue&type=style&index=0&id=7275d748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275d748",
  null
  
)

export default component.exports